// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Lottie } from "@edclub/player";

import { useCrosswordStore } from "@/store";

export type MoodType = "calm" | "happy" | "celebrate" | "wonder";

interface Mood {
  path: string;
  bounds: {
    right: string;
    bottom: number;
    width: number;
  };
  delay?: number;
}

type Moods = {
  [mood in MoodType]: Mood;
};

export function AnimatedGiraffe() {
  const giraffeMood = useCrosswordStore.use.giraffeMood();

  const moods: Moods = {
    calm: {
      path: "/anims/Giraffe_Calm.json",
      bounds: {
        right: "calc(100% - 160px)",
        bottom: -100,
        width: 120,
      },
      delay: 1,
    },
    happy: {
      path: "/anims/Giraffe_Happy.json",
      bounds: {
        right: "calc(100% - 160px)",
        bottom: -100,
        width: 120,
      },
    },
    celebrate: {
      path: "/anims/Giraffe_Celebrate.json",
      bounds: {
        right: "calc(100% - 227px)",
        bottom: -143,
        width: 144,
      },
    },
    wonder: {
      path: "/anims/Giraffe_Wonder.json",
      bounds: {
        right: "calc(100% - 160px)",
        bottom: -100,
        width: 120,
      },
    },
  };

  const scene = moods[giraffeMood];

  return (
    <div className="absolute bottom-0 left-0 z-10" aria-hidden="true">
      <Lottie path={scene.path} delay={scene?.delay} bounds={scene.bounds} />
    </div>
  );
}
